import styled, { css } from 'styled-components'

import Link from '../Link'
import Icon from '../Icon'

export const Pagination = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`
export const Arrow = styled(Icon)`
  margin: 0 0.5rem;
`
export const Item = styled(Link)<{ $active?: boolean }>`
  ${({ $active, theme }) =>
    $active &&
    css`
      ${theme.textStyles.firaSansTextBaseBold}
      color: ${theme.colors.pinkPrimary};
    `};
`
